import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { SubscriptionCodeBreakdown } from '../../../../services/user-analytics/user-analytics.model';

@Component({
    selector: 'app-user-subscription-code-chart',
    templateUrl: './user-subscription-code-chart.component.html',
    styleUrls: ['./user-subscription-code-chart.component.scss'],
})
export class UserSubscriptionCodeChartComponent implements OnChanges {
    @Input() data: SubscriptionCodeBreakdown[] = [];

    chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'bar'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: { legend: { display: false } },
        scales: {
            x: { beginAtZero: true, ticks: { precision: 0 } },
            y: { grid: { display: false } },
        },
    };

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((d) => d.code),
            datasets: [
                {
                    data: this.data.map((d) => d.count),
                    backgroundColor: '#3a7bd5',
                    borderRadius: 4,
                },
            ],
        };
    }
}
